// eslint-disable-next-line no-restricted-imports
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';

const TENANT_SUSPENDED_RESPONSE = 'Site temporarily unavailable'; // Atlassian proxy returns this error json when tenant region migration is in process -> { error: "503", message: dataJson.errorMessage }

export const experimentalEditorStartHeartbeat: ExperimentalMutations['experimentalEditorStartHeartbeat'] =
	async (_, { contentId, contentType, collabService, heartbeatUserType }, { network }) => {
		const heartbeatUrl = '/wiki/api/v2/editor/heartbeat/start';
		const body = {
			dataType: 'json',
			contentId,
			draftType: contentType ?? '',
			collabService,
			// confluence-frontend only sends heartbeat for Fabric editor, legacy editor heartbeat code is in confluence web resource.
			// heartbeat response is different for each editor version; only fabric heartbeat response in handled in this experimental mutation
			editorVersion: 'v2',
			heartbeatUserType,
		};
		const requestOptions: RequestInit = {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				'Content-Type': MediaType.JSON,
				Accept: MediaType.JSON,
			},
		};

		try {
			const res = await network.cfetch(heartbeatUrl, requestOptions);
			return await res.json();
		} catch (fetchError) {
			// this catches unhandled server errors (e.g. internal server error)
			if (fetchError instanceof network.BadStatusError) {
				try {
					// try to parse original error message
					const errorMessageJson = await fetchError.response.json();

					if (errorMessageJson?.errorMessage === TENANT_SUSPENDED_RESPONSE) {
						// error from atlassian-proxy during region migration
						return {
							error: 'tenant-unavailable',
							message: 'Site temporarily unavailable',
						};
					}

					// Parse heartbeat REST error response
					return {
						error: errorMessageJson?.errors[0].code,
						message: errorMessageJson?.errors[0].title,
					};
				} catch {
					return {
						error: fetchError.response.statusText,
						message: fetchError.message,
					};
				}
			}
			return {
				error: fetchError.name,
				message: fetchError.message,
			};
		}
	};
